export default function SafetyDisclaimer() {
  return (
    <section className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="bg-background-50 rounded-xl border border-background-200/60 p-6 md:p-8">
          <div className="flex items-start gap-4">
            <div className="w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg bg-foreground-100 text-foreground-500">
              <i className="ri-information-line text-base"></i>
            </div>
            <div>
              <h3 className="font-heading text-lg font-semibold text-foreground-800 mb-3">Important Safety Disclaimer</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                This website provides independent educational information only. We do not guarantee product availability, seller quality, shipping results, or third-party services. Users should verify all information before making purchase decisions. All external links to kaspreadsheet.com are provided for convenience and do not constitute an endorsement. Basetao Sheet is an independent resource and is not affiliated with or endorsed by any specific platform.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}